var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwittericonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42857 0.75C1.5375 0.75 0 2.22344 0 4.03571V20.4643C0 22.2766 1.5375 23.75 3.42857 23.75H20.5714C22.4625 23.75 24 22.2766 24 20.4643V4.03571C24 2.22344 22.4625 0.75 20.5714 0.75H3.42857ZM19.3446 5.0625L13.7839 11.1513L20.325 19.4375H15.2036L11.1964 14.4114L6.60536 19.4375H4.06071L10.0071 12.9225L3.73393 5.0625H8.98393L12.6107 9.65737L16.8 5.0625H19.3446ZM17.3196 17.9795L8.21786 6.44353H6.70179L15.9054 17.9795H17.3143H17.3196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittericonWhite);
export default __webpack_public_path__ + "static/media/twittericon-white.92db8951fa17e1c2133150c0d2388ac1.svg";
export { ForwardRef as ReactComponent };